import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { BillType, ITables, TABLE_STATUS } from '../../../all-types'
import {
  createLatestBill,
  getTableById,
  updateCartItemOfTheTable,
} from '../../../services'
import { defaultBillType } from '../bill-cart'

const initialState: {
  selectedTable: ITables | null
  createdBill: BillType | null
  isTakeAway: boolean
} = {
  selectedTable: null,
  createdBill: null,
  isTakeAway: false,
}

export const TableSession = createSlice({
  name: 'table-session',
  initialState,
  reducers: {
    setSelectedTable: (state, action: PayloadAction<ITables | null>) => {
      if (action.payload === null) {
        state.selectedTable = null
        state.createdBill = null
        return
      }

      const billSession = action.payload?.billSession

      if (!billSession) {
        state.selectedTable = {
          ...action.payload,
          billSession: defaultBillType,
        }
      } else {
        state.selectedTable = action.payload
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTableById.fulfilled, (state, action) => {
        if (action.payload === null) {
          state.selectedTable = null
          return
        }

        const billSession = action.payload?.billSession

        if (!billSession) {
          state.selectedTable = {
            ...action.payload,
            billSession: defaultBillType,
          }
        } else {
          state.selectedTable = action.payload
        }
      })
      .addCase(updateCartItemOfTheTable.fulfilled, (state, action) => {
        state.selectedTable = action.payload
      })
      .addCase(createLatestBill.fulfilled, (state, action) => {
        state.createdBill = action.payload
      })
  },
})

export const { setSelectedTable } = TableSession.actions
